import { render } from "./BackNumberPage.vue?vue&type=template&id=7bd450cd&scoped=true"
import script from "./BackNumberPage.vue?vue&type=script&lang=js"
export * from "./BackNumberPage.vue?vue&type=script&lang=js"

import "./BackNumberPage.vue?vue&type=style&index=0&id=7bd450cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd450cd"]])

export default __exports__